<template lang="pug">
  layout-form(form="user" :value="user" @afterSave="afterSave")
</template>

<script>
import { mapGetters } from 'vuex';
import User from '@/models/User';

export default {
  name: 'view-control-users-edit',

  props: {
    userId: null,
    groupId: null,
  },

  data: () => ({
    model: User,
    user: new User(),
    tabs: [{ label: 'Редактирование', active: true }],
  }),

  computed: {
    ...mapGetters(['userGroups']),
  },

  watch: {
    userId() {
      this.loadUser();
    },
  },

  methods: {
    loadUser() {
      if (this.userId) {
        this.user.$find(this.userId);
      } else {
        this.user.group_id = parseInt(this.groupId);
      }
    },

    afterSave(user) {
      // Переадресация на страницу редактирования после создания пользователя
      // Либо изменение в урле :groupId
      if (!this.userId || this.groupId != user.group_id) {
        this.$router.replace({ params: { groupId: user.group_id, userId: user.id } });
      }
    },
  },

  created() {
    this.loadUser();
  },
};
</script>
